import { useEffect } from 'react';
import CustomSegment from '../../../../components/CustomSegment';
import PageTitle from '../../../../components/PageTitle';
import MODULES from '../../../../config/modules.config';
import { useQueryFilters } from '../../../../hooks/useQueryFilters';
import { useSegment } from '../../../../hooks/useSegment';
import DashboardLayout from '../../../../layouts/DashboardLayout';
import type { SegmentedType } from '../../../../types/global.types';
import ShiftAndRoasterFilter from './_components/ShiftAndRoaster/ShiftAndRoasterFilter';
import SummaryFilter from './_components/Summery/SummaryFilter';
import WorkTimeReportFilter from './_components/WorkTimeReport/WorkTimeReportFilter';
import ShiftAndRoaster from './ShiftAndRoaster';
import Summery from './Summery';
import WorkTimeReport from './WorkTimeReport';

type SegmentType = 'summery' | 'shift_roaster_management' | 'work_time_report';

const EmpAttendance = () => {
  const { clearFilters } = useQueryFilters();

  const { segment, setSegment } = useSegment<SegmentType>(
    'emp-attendance-segment',
    'summery',
    true,
  );
  const SEGMENT_CONFIG: SegmentedType<SegmentType>[] = [
    {
      value: 'summery',
      label: 'Summary',
      view: <Summery />,
    },
    {
      moduleId: MODULES.EMPLOYEE_SHIFT_MANAGEMENT,
      value: 'shift_roaster_management',
      label: 'Shift Management',
      view: <ShiftAndRoaster />,
    },
    {
      value: 'work_time_report',
      label: 'Worktime Report',
      view: <WorkTimeReport />,
    },
  ];

  const currentSegment = SEGMENT_CONFIG.find((s) => s.value === segment);

  useEffect(() => {
    clearFilters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [segment]);

  return (
    <DashboardLayout title="Attendance">
      <PageTitle
        title="Attendance"
        items={[
          { title: 'Dashboard', path: '/admin/employee/dashboard' },
          { title: currentSegment?.label },
        ]}
      >
        {currentSegment?.value === 'summery' && <SummaryFilter />}
        {currentSegment?.value === 'shift_roaster_management' && (
          <ShiftAndRoasterFilter />
        )}
        {currentSegment?.value === 'work_time_report' && (
          <WorkTimeReportFilter />
        )}
      </PageTitle>

      <CustomSegment
        config={SEGMENT_CONFIG}
        selected={segment}
        onChange={setSegment}
      />

      <div className="mt-5">{currentSegment?.view}</div>
    </DashboardLayout>
  );
};

export default EmpAttendance;
